/**
 * Predicate control — minimal segmented Is / Is not.
 */

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import type { ConditionPredicate } from '../model';

export interface ConditionRowPredicateSelectProps {
  predicate: ConditionPredicate;
  onChange: (next: ConditionPredicate) => void;
  ariaLabel: string;
  disabled?: boolean;
}

const ConditionRowPredicateSelect: FC<ConditionRowPredicateSelectProps> = ({
  predicate,
  onChange,
  ariaLabel,
  disabled,
}) => (
  <div
    role="group"
    aria-label={ariaLabel}
    className={cn(
      'inline-flex rounded border border-border/60 bg-muted/20 p-px',
      disabled && 'pointer-events-none opacity-50',
    )}
  >
    <button
      type="button"
      aria-pressed={predicate === 'MUST_BE'}
      disabled={disabled}
      onClick={() => onChange('MUST_BE')}
      className={cn(
        'rounded-sm px-1.5 py-0.5 text-[11px] font-medium transition-colors',
        predicate === 'MUST_BE'
          ? 'bg-background text-foreground shadow-sm'
          : 'text-muted-foreground hover:text-foreground',
      )}
    >
      Is
    </button>
    <button
      type="button"
      aria-pressed={predicate === 'MUST_NOT_BE'}
      disabled={disabled}
      onClick={() => onChange('MUST_NOT_BE')}
      className={cn(
        'rounded-sm px-1.5 py-0.5 text-[11px] font-medium transition-colors',
        predicate === 'MUST_NOT_BE'
          ? 'bg-background text-foreground shadow-sm'
          : 'text-muted-foreground hover:text-foreground',
      )}
    >
      Is not
    </button>
  </div>
);

export default ConditionRowPredicateSelect;
